module.exports = __webpack_public_path__ + "static/media/facebook.c29888b3.svg";